import { render, staticRenderFns } from "./VoicedAndDeafConsonantsPreview.vue?vue&type=template&id=002cb7bc&lang=pug&"
import script from "./VoicedAndDeafConsonantsPreview.vue?vue&type=script&lang=js&"
export * from "./VoicedAndDeafConsonantsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports